<template>
  <BreadCrumb page="Beranda > Tools > Simulator Pembayaran"></BreadCrumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-md-10">
        <h3 class="judul-seksi-sga">Simulator Payment </h3>
      </div>
    </div>
    <div class="form-general">
      <div class="row">
        <div class="col-md-6">
          <input type="text" v-model="data.invid" class="form-control mb-4" placeholder="Masukan ID Formulir">
          <input type="text" v-model="data.password" class="form-control mb-4" placeholder="Masukan Password Simulator">
          <button @click="simulatorpayment('biaya-formulir')" class="btn btn-sm btn-success mr-2" type="button"> Bayar Biaya Formulir</button>
          <button @click="simulatorpayment('biaya-konfirmasi')" class="btn btn-sm btn-success" type="button"> Bayar Biaya Konfirmasi</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          {{message}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";

export default {
  name: "PageDevelopmentTools",
  components: {BreadCrumb},
  data:()=>({
    loading: false,
    response:"",
    message:"",
    data:{
      invid: "",
      paymenttype:"",
      password:""
    }
  }),
  methods:{
    simulatorpayment(type){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      this.data.paymenttype = type;
      let data = this.data;
      let path = '/dashboard/simulatebayar';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
  }
}
</script>

<style scoped>

</style>